import { Provider } from '@angular/core';
import { I18nService } from '@app/shared/services/i18n/i18n.service';

export const I18N_SERVICES: Provider[] = [I18nService];
